import {
  useState,
  useEffect,
  useCallback,
} from 'react';
import {
  Calendar,
} from 'react-big-calendar';

import {
  DateTime,
} from 'luxon';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  ActivityModal,
  WorkoutResultModal,
} from 'web-components';

import {
  Flex,
  TextOverflowDots,
} from 'web-styled';

import {
  uiActions,
} from 'web-actions';

import LuxonLocalizer from 'web-components/Calendar/luxonLocalizer';
import Toolbar from './Toolbar';

import * as S from './styled';

type Props = {
  clientInfo: any,
};

type GetComponentProps = {
  event: any,
};

const getComponents = () => ({
  toolbar: (props: any) => (
    <Toolbar
      {...props}
    />
  ),
  event: ({ event }: GetComponentProps) => (
    <Flex
      noScroll
    >
      <TextOverflowDots
        weight={500}
        color="#fff"
        size="11px"
        lineHeight="11px"
      >
        {`${event.startTime} ${event.title}`}
      </TextOverflowDots>
    </Flex>
  ),
});

const CalendarTab = ({ clientInfo }: Props) => {
  const clientId = clientInfo.id;
  const [selectedLog, setSelectedLog] = useState<any>(null);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);

  const mapState = useCallback(state => ({
    events: coreSelectors.getEventsForBigCalendar(clientId)(state),
  }), [clientId]);

  const { events } = useSelector(mapState, shallowEqual);

  const dispatch = useDispatch();

  const fetchEvents = ({ from, to }: { from: DateTime, to: DateTime }) => {
    dispatch(
      coreActions.requestLoadWorkoutEvents({
        params: {
          range_from: from,
          range_to: to,
        },
        userId: clientId,
        page: 1,
        fetchAll: true,
      }),
    );
    dispatch(
      coreActions.requestFetchClientEntity({
        clientId,
        params: {
          range_from: from,
          range_to: to,
        },
        list: String(clientId),
        resourceType: 'activityLogs',
      }),
    );
  };

  useEffect(() => {
    fetchEvents({
      from: DateTime.utc().startOf('month'),
      to: DateTime.utc().endOf('month'),
    });
    dispatch(coreActions.requestLoadPersonalWorkouts({
      userId: clientId,
    }));
  }, []);

  return (
    <S.CalendarContainer>
      <Calendar
        style={{
          width: '100%',
        }}
        views={['month']}
        popup
        selectable
        events={events}
        onSelectEvent={(event) => {
          if (event.isLog) setSelectedLog(event);
          if (!event.isLog) setSelectedEvent(event);
        }}
        onSelectSlot={({ start }) => {
          dispatch(uiActions.setUiState({ currentCalendarDate: new Date(start) }));
        }}
        components={getComponents()}
        localizer={LuxonLocalizer({ firstDayOfWeek: 0 })}
        startAccessor="start"
        endAccessor="end"
        onNavigate={(day) => {
          fetchEvents({
            from: DateTime.fromJSDate(day).toUTC().startOf('month'),
            to: DateTime.fromJSDate(day).toUTC().endOf('month'),
          });
        }}
      />
      <ActivityModal
        id={selectedLog?.id}
        onRequestClose={() => setSelectedLog(null)}
      />
      <WorkoutResultModal
        id={selectedEvent?.id}
        onRequestClose={() => setSelectedEvent(null)}
      />
    </S.CalendarContainer>
  );
};

export default CalendarTab;
